import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../../Components/helper';
import UploadDocuments from './UploadDocument';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import * as componentAction from '../../../store/component.action';
import EditDocumentDetails from './EditDocumentDetails';
import PreviewModal from './PreviewModel';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';

function PurchaseOrderDocuments({ onOpen, toggle, data }) {
  const dispatch = useDispatch();
  const dateFormat = 'DD-MMM-YYYY, h:mm';
  const { t } = useTranslation('common');
  const {
    ComponentOrderReducer: { poDocumets },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);

  const [state, setState] = useState({
    loading: false,
    openPreview: false,
    previewData: null,
    openDeleteModal: false,
    deleteIds: '',
    selectedIdArray: [],
    selectAll: false,
    openEditPopup: false,
    openUploadDocs: false,
    showNameErr: false,
    editPopupData: null,
    supplierData: [],
    userData: [],
  });

  const handlePreview = (element) => {
    setState((prevState) => ({
      ...prevState,
      openPreview: true,
      previewData: element,
    }));
  };

  const supplierVisibility = (ele, obj) => {
    return isSupplierLoggedIn ? ele?.isVisibleToSupplier && obj : obj;
  };

  const handleDelete = (element) => {
    setState((eleState) => ({
      ...eleState,
      openDeleteModal: true,
      deleteIds: element._id,
    }));
  };

  const downLoadDocuments = async (element) => {
    const obj = {
      filename: element.fileName,
      path: element.path,
    };
    await dispatch(componentAction.downloadPODoc(obj));
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...state.selectedIdArray];
    if (e?.target?.checked) {
      setState((selectState) => ({
        ...selectState,
        selectedIdArray: [...state.selectedIdArray, id],
        selectAll: state.userData.length === [...state.selectedIdArray, id]?.length,
      }));
    } else {
      selectedItems = selectedItems?.filter((item) => item !== id);
      setState((selectState) => ({
        ...selectState,
        selectedIdArray: [...selectedItems],
        selectAll: false,
      }));
    }
  };

  const handleSelectAll = () => {
    if (state.selectAll) {
      setState((newState) => ({
        ...newState,
        selectedIdArray: [],
      }));
    } else {
      const selectedItems = [...state.selectedIdArray];
      state.userData.forEach((item) => {
        const findItem = selectedItems.find((val) => val === item._id);
        if (!findItem) {
          selectedItems.push(item._id);
        }
      });
      setState((prevDocState) => ({
        ...prevDocState,
        selectedIdArray: [...selectedItems],
      }));
    }
    setState((originalState) => ({
      ...originalState,
      selectAll: !state.selectAll,
    }));
  };

  const handleEdit = (element) => {
    setState((elementState) => ({
      ...elementState,
      editPopupData: element,
      openEditPopup: true,
    }));
  };
  const uploadDocs = () => {
    setState((oldState) => ({ ...oldState, openUploadDocs: true }));
  };

  useEffect(() => {
    const filteredData = poDocumets.filter(
      (e) =>
        e?.modifiedBy?.role === 'Supplier' ||
        e?.createdBy?.role === 'Supplier' ||
        e?.modifiedBy?.role === 'SupplierUser' ||
        e?.createdBy?.role === 'SupplierUser',
    );
    const forAdminLogIn = () => {
      return poDocumets.filter(
        (e) => e?.modifiedBy?.role === 'Admin' || e?.createdBy?.role === 'Admin' || e?.modifiedBy?.role === 'User' || e?.createdBy?.role === 'User',
      );
    };

    const forSupplierLoggedIn = () => {
      return poDocumets.filter(
        (e) =>
          (e?.modifiedBy?.role === 'Admin' || e?.createdBy?.role === 'Admin' || e?.modifiedBy?.role === 'User' || e?.createdBy?.role === 'User') &&
          e.isVisibleToSupplier === true,
      );
    };

    const userData = isSupplierLoggedIn ? forSupplierLoggedIn() : forAdminLogIn();

    setState((suppData) => ({
      ...suppData,
      supplierData: [...filteredData],
      userData: [...userData],
    }));
  }, [poDocumets, isSupplierLoggedIn]);

  const toggleEdit = async () => {
    const res = await dispatch(componentAction.fetchPurchaseOrderDocument(data._id));
    if (res) {
      setState((editEnd) => ({
        ...editEnd,
        editPopupData: null,
        openEditPopup: false,
        loading: false,
      }));
    }
  };

  const handleSubmit = async (ele) => {
    const params = {
      fileName: ele?.docName,
      id: state?.editPopupData?._id,
    };
    const payload = {
      isVisibleToSupplier: ele?.isVisibleToSupplier,
      notes: ele?.notes,
      status: ele?.status?.name,
    };
    if (ele?.docName.trim()) {
      const res = await dispatch(componentAction.putPurchaseOrderDocuments(params, payload, t));
      if (res) {
        toggleEdit();
      }
    } else {
      setState((oldState) => ({ ...oldState, showNameErr: true }));
    }
  };

  const toggleUploadDocs = async () => {
    const res = await dispatch(componentAction.fetchPurchaseOrderDocument(data._id));
    if (res) {
      setState((tempState) => ({ ...tempState, openUploadDocs: false }));
    }
  };

  const togglePreview = () => {
    setState((oldState) => ({
      ...oldState,
      openPreview: false,
      previewData: null,
    }));
  };
  const toggleDelete = () => {
    setState((eleStateend) => ({
      ...eleStateend,
      openDeleteModal: false,
      deleteIds: '',
      selectedIdArray: [],
      selectAll: false,
      loading: false,
    }));
  };

  const deletedocs = async () => {
    if (!isEmpty(state.deleteIds)) {
      setState((deleteState) => ({ ...deleteState, loading: true }));
      const params = { ids: state.deleteIds };
      await dispatch(componentAction.deletePODocuments(params, data._id, t));
      const res = await dispatch(componentAction.fetchPurchaseOrderDocument(data._id));
      if (res) {
        toggleDelete();
      }
    } else {
      setState((prevSatte) => ({ ...prevSatte, loading: true }));
      const params = {
        ids: state.selectedIdArray.join(','),
      };
      await dispatch(componentAction.deletePODocuments(params, data._id, t, 'multi'));
      const res = await dispatch(componentAction.fetchPurchaseOrderDocument(data._id));
      if (res) {
        toggleDelete();
      }
    }
  };
  const multiDelete = async () => {
    setState((multiDel) => ({
      ...multiDel,
      openDeleteModal: true,
    }));
  };

  return (
    <>
      <Modal
        show={onOpen}
        backdrop="static"
        className="custom-modal modal-medium-4x moda-fullpage"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={toggle}
      >
        <Modal.Header>
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div className="title-container">
                <span className="title">
                  {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.TITLE')} {data?.purchaseOrderNo}{' '}
                </span>
              </div>
              {!isSupplierLoggedIn && (
                <div className="d-flex">
                  <button
                    type="button"
                    title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.UPLOAD_DOCUMENT')}
                    className="btn btn-outline"
                    onClick={uploadDocs}
                  >
                    <span className="icon-upload" />
                  </button>

                  <button
                    type="button"
                    title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DELETE_DOCUMENTS')}
                    className="btn btn-outline px-1"
                    disabled={isEmpty(state.selectedIdArray)}
                    onClick={multiDelete}
                  >
                    <span className="icon-delete" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {state.loading && <Loader />}
          {!state.loading && (
            <>
              <div className="modal-buttons mt-5 justify-content-between">
                <div>
                  <span>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.USER_UPLOADED')}</span>
                </div>
                <div className="table-responsive">
                  <table className="table custom-table font-13 mb-5">
                    <thead>
                      <th className="w-80px">
                        <div className="checkbox-label no-label margin-auto">
                          <input type="checkbox" onChange={handleSelectAll} name="check_all" id="check_all" checked={state.selectAll} />
                          <label htmlFor="check_all" className="chklabel">
                            <span />
                          </label>
                        </div>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DOCUMENT_NAME')}
                        </span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.SIZE')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.STATUS')}
                        </span>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.NOTES')}
                        </span>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.CREATED_BY_DATE_TIME')}
                        </span>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.MODIFIED_BY_DATE_TIME')}
                        </span>
                      </th>
                      <th>
                        <span className="cursor-pointer">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.ACTION')}
                        </span>
                      </th>
                    </thead>
                    <tbody>
                      {checkArray(state.userData) &&
                        state.userData.map((ele) => {
                          return (
                            <tr key={ele?._id}>
                              <td>
                                {supplierVisibility(
                                  ele,
                                  <div className="checkbox-label no-label margin-auto">
                                    <input
                                      onChange={(e) => onSelectCheckBox(e, ele._id)}
                                      name={`checks_${ele?._id}`}
                                      id={`checks_${ele?._id}`}
                                      type="checkbox"
                                      checked={state.selectedIdArray.filter((val) => val === ele._id).length > 0}
                                    />
                                    <label htmlFor={`checks_${ele?._id}`} className="chklabel" />
                                  </div>,
                                )}
                              </td>
                              <td>{supplierVisibility(ele, ele?.fileName)}</td>
                              <td>{supplierVisibility(ele, ele?.size && `${ele?.size} ${ele?.unit}`)}</td>
                              <td>{supplierVisibility(ele, ele?.status)}</td>
                              <td>{supplierVisibility(ele, ele?.notes)}</td>
                              <td>
                                {supplierVisibility(ele, ele?.createdBy && `${ele?.createdBy?.firstName} ${ele?.createdBy?.lastName}`)}
                                <br />
                                {supplierVisibility(ele, ele?.createdAt && moment(ele?.createdAt).format(dateFormat))}
                              </td>
                              <td>
                                {supplierVisibility(ele, ele?.modifiedBy && `${ele?.modifiedBy?.firstName} ${ele?.modifiedBy?.lastName}`)}
                                <br />
                                {supplierVisibility(ele, ele?.updatedAt && moment(ele?.updatedAt).format(dateFormat))}
                              </td>
                              <td>
                                {supplierVisibility(
                                  ele,
                                  <>
                                    {!isSupplierLoggedIn && (
                                      <button
                                        type="button"
                                        className="btn-tbl-action"
                                        title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.EDIT')}
                                        onClick={() => handleEdit(ele)}
                                      >
                                        <span className="icon-edit" />
                                      </button>
                                    )}

                                    <button
                                      type="button"
                                      className="btn-tbl-action"
                                      title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.PREVIEW')}
                                      onClick={() => handlePreview(ele)}
                                    >
                                      <span className="icon-preview-template" />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn-tbl-action"
                                      title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DOWNLOAD')}
                                    >
                                      <a
                                        href={() => {
                                          return false;
                                        }}
                                        onClick={() => downLoadDocuments(ele)}
                                        className=" colour-black text-decoration-none"
                                      >
                                        <span className="icon-download" />
                                      </a>
                                    </button>

                                    <button
                                      type="button"
                                      className="btn-tbl-action"
                                      title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DELETE')}
                                      onClick={() => handleDelete(ele)}
                                    >
                                      <span className="icon-delete" />
                                    </button>
                                  </>,
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {isEmpty(state.userData) && (
                        <tr>
                          <td colSpan={8}>
                            <span className="align-items-center justify-content-center d-flex">
                              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.NO_DOCUMENTS_FOUND')}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <button onClick={toggle} type="button" className="btn btn-default">
                  {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.CANCEL')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      {state.openEditPopup && (
        <EditDocumentDetails
          onOpen={state.openEditPopup}
          data={state.editPopupData}
          handleSubmit={handleSubmit}
          toggle={toggleEdit}
          loading={state.loading}
          showErr={state.showNameErr}
        />
      )}
      {state.openUploadDocs && <UploadDocuments setShowGradingGroupError={() => {}} onOpen={state.openUploadDocs} toggle={toggleUploadDocs} showData={data} />}
      {state.openPreview && <PreviewModal onOpen={state.previewData} toggle={togglePreview} data={state.previewData} />}
      {state.openDeleteModal && (
        <ConfirmationPopup
          onOpen={state.openDeleteModal}
          onConfirm={deletedocs}
          loading={state.loading}
          title={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DELETE_CONFIRM_TITLE')}
          message={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PURCHASE_ORDER_DOCUMENTS.DELETE_CONFIRM_MESSAGE')}
          toggle={toggleDelete}
        />
      )}
    </>
  );
}

export default PurchaseOrderDocuments;
